export default "__VITE_ASSET__DXRwBQ2i__"